export enum CooperationPartnerChannel {
  CREATE = 'cooperationPartner::create',
  EDIT = 'cooperationPartner::patch',
  DELETE = 'cooperationPartner::delete',
}
